import React, { CSSProperties, PropsWithChildren } from "react";
import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Column } from "../types";

interface Props<Data extends Record<string, any>, Context extends any = any> {
  context: Context;
  column: Column<Data, Context>;
  sx?: CSSProperties;
}

export const TableCell = <Data extends Record<string, any>, Context extends any = any>({
  sx,
  column,
  children,
}: PropsWithChildren<Props<Data, Context>>) => (
  <Box
    sx={{
      gap: "0.5rem",
      display: "flex",
      minHeight: "3.5rem",
      alignItems: "center",
      padding: "0.5rem 1rem",
      minWidth: column.width ?? "20rem",
      outline: `1px solid ${grey["300"]}`,
      ...sx,
    }}>
    {children}
  </Box>
);
